
import { useTranslation } from 'react-i18next';

export function Services() {
  const { t } = useTranslation('common');

  const services = [
    {
      icon: 'ri-shield-check-fill',
      title: t('services.inmetro.title'),
      description: t('services.inmetro.description'),
      color: 'bg-orange-500'
    },
    {
      icon: 'ri-signal-tower-fill',
      title: t('services.anatel.title'),
      description: t('services.anatel.description'),
      color: 'bg-blue-900'
    },
    {
      icon: 'ri-heart-pulse-fill',
      title: t('services.anvisa.title'),
      description: t('services.anvisa.description'),
      color: 'bg-orange-500'
    },
    {
      icon: 'ri-building-fill',
      title: t('services.suppliers.title'),
      description: t('services.suppliers.description'),
      color: 'bg-blue-900'
    },
    {
      icon: 'ri-flask-fill',
      title: t('services.testing.title'),
      description: t('services.testing.description'),
      color: 'bg-orange-500'
    },
    {
      icon: 'ri-lightbulb-fill',
      title: t('services.consulting.title'),
      description: t('services.consulting.description'),
      color: 'bg-blue-900'
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className={`w-16 h-16 ${service.color} rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
